<div class="tab-content">
  <div id="districtapprovals" role="tabpanel" class="tab-pane active collapse show">
    <div class="row">
      <div class="col-md-12">
        <div class="tab" role="tabpanel">
          <ul class="nav nav-tabs" role="tablist" style="margin-top: 0px;">
            <li role="presentation" class="nav-item pointer" style="width: 50%;"><a style="margin: 0px;"
                class="nav-link" [ngClass]="{'active': activesidetab == 'thememandate'}"
                (click)="navtabclick('thememandate')" name="thememandate" aria-selected="true">{{ 'themeandassessment.Themes Mandatory' | translate}}</a></li>
            <li role="presentation" class="nav-item pointer"><a style="margin: 0px;" class="nav-link"
                [ngClass]="{'active': activesidetab == 'assesmentyractive'}" (click)="navtabclick('assesmentyractive')"
                name="assesmentyractive" aria-selected="false">{{ 'themeandassessment.Assessment Year' | translate }}</a></li>
          </ul>

          <div class="tab-content" *ngIf="activesidetab == 'thememandate'">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-lg-12">
                    <h5 class="border-bottom pb-2 mb-2">{{ 'themeandassessment.selecttheme' | translate }}</h5>
                  </div>

                  <div class="col-md-12 d-flex justify-content-start px-3">
                    <div class="row">
                      <div class="col-12 col-xl col-md-6">
                        <div class="form-group">
                          <label>{{'header.assesmentyear' | translate }}<span class="required-field">*</span></label>
                          <select [(ngModel)]="selectedYearMonth['ay']" class="form-control custom-selectbox">
                            <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-12 col-xl col-md-6">
                        <div class="form-group">
                          <label>{{'dataSubs.month' | translate }}<span class="required-field">*</span></label>
                          <select [(ngModel)]="selectedYearMonth['month']" class="form-control custom-selectbox">
                            <option value="" [disabled]="true">{{'monthmaps.selcecttag' | translate}}</option>
                            <option *ngFor="let month of monthList" [value]="month.key">
                              {{'monthmaps.' + month['value'] | translate}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="col d-flex justify-content-start align-items-end">
                      <div class="form-group">
                        <label class="w-100">&nbsp;&nbsp;<span class="required-field"></span></label>
                        <button class="btn btn-info pointer" (click)="getThemes()" type="submit">{{ 'themeandassessment.view' | translate}}</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12" *ngIf="themeData">
                  <div class="table-responsive" style="height: 425px;">
                    <table class="table table-sm text-center">
                      <thead>
                        <tr>
                          <th scope="col">{{ 'submitdata.slno' | translate }}</th>
                          <th scope="col">{{ 'dataSubs.themes' | translate }} </th>
                          <th scope="col" style="width: 35%;">{{ 'themeandassessment.Themes to be made mandatory for' | translate}} {{currentMonthVar}}
                            {{selectedYearMonth['ay']}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let theme of themeData; let i=index">
                          <td>{{i+1}}</td>
                          <td>{{ 'themedataObj.' + theme['label'] | translate }}</td>
                          <td>
                            <form>
                              <input type="radio" name="theme['mandate']" value="yes" [(ngModel)]="theme['mandate']" class="pointer"
                                (ngModelChange)="selectTheme(theme)">
                            </form>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="d-flex align-items-center justify-content-end align-self-end">
                    <button class="btn btn-large pointer mr-2" (click)="resetMandateThemes()"
                      type="submit">{{ 'submitdata.reset' | translate }}</button>
                    <button class="btn btn-large pointer" (click)="submitMandateThemes()" type="submit">{{ 'header.submit' | translate}} </button>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>

          <div class="tab-content" *ngIf="activesidetab == 'assesmentyractive'">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-lg-12">
                    <h5 class="border-bottom pb-2 mb-2">{{ 'themeandassessment.selectassessmentyear' | translate}}
                    </h5>
                  </div>

                  <div class="col-md-12 d-flex justify-content-start px-3">
                    <div class="form-group ">
                      <label>{{'header.assesmentyear' | translate }}<span class="required-field">*</span></label>
                      <select [(ngModel)]="activDeactivYear" class="form-control custom-selectbox w-auto"
                        style="display: inline;margin-left: 10px;">
                        <option *ngFor="let year of yearList" value="{{year}}">{{year}}</option>
                      </select>
                    </div>
                    <div class="form-group" style="margin-left: 35px;">
                      <!-- <label class="w-100">&nbsp;&nbsp;<span class="required-field"></span></label> -->
                      <button class="btn btn-large pointer" (click)="setActivateYear()" type="submit">{{ 'themeandassessment.activate' | translate}}</button>
                    </div>
                    <div class="form-group" style="margin-left: 35px;">
                      <button class="btn btn-large pointer"(click)="setDeactivateYear()" type="submit">{{ 'themeandassessment.deactivate' | translate}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
